export default __webpack_public_path__ + "static/media/charging jack replacement.cef13d0f.png";